export default __webpack_public_path__ + "static/media/logo-large-white.3f2bb830.png";